import React from 'react';
import { ThumbsUpIcon, MessageSquareIcon, UserPlusIcon, ClockIcon, Share2Icon, MailIcon } from 'lucide-react';
export const RecentActivity: React.FC = () => {
  const activities = [{
    id: 1,
    type: 'engagement',
    action: 'liked',
    person: 'Sarah Johnson',
    time: '10 minutes ago',
    target: 'your post about AI in sales'
  }, {
    id: 2,
    type: 'connection',
    person: 'Michael Chen',
    time: '1 hour ago',
    position: 'Marketing Director at TechCorp'
  }, {
    id: 3,
    type: 'engagement',
    action: 'commented',
    person: 'Emily Rodriguez',
    time: '2 hours ago',
    target: 'your article about lead generation'
  }, {
    id: 4,
    type: 'message',
    person: 'David Wilson',
    time: '3 hours ago',
    preview: 'Thanks for reaching out about...'
  }, {
    id: 5,
    type: 'engagement',
    action: 'shared',
    person: 'Lisa Thompson',
    time: '5 hours ago',
    target: 'your post about industry trends'
  }];
  const getActivityIcon = (activity: (typeof activities)[0]) => {
    switch (activity.type) {
      case 'engagement':
        if (activity.action === 'liked') return <ThumbsUpIcon size={14} className="text-blue-600" data-id="element-1087" />;
        if (activity.action === 'commented') return <MessageSquareIcon size={14} className="text-purple-600" data-id="element-1088" />;
        if (activity.action === 'shared') return <Share2Icon size={14} className="text-green-600" data-id="element-1089" />;
        return null;
      case 'connection':
        return <UserPlusIcon size={14} className="text-indigo-600" data-id="element-1090" />;
      case 'message':
        return <MailIcon size={14} className="text-amber-600" data-id="element-1091" />;
      default:
        return null;
    }
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-id="element-1092">
      <div className="flex justify-between items-center mb-4" data-id="element-1093">
        <h3 className="text-md font-medium text-gray-900" data-id="element-1094">Recent Activity</h3>
        <button className="text-sm text-[#f9b30f] hover:text-[#e0a40e]" data-id="element-1095">
          View All
        </button>
      </div>
      <div className="space-y-3" data-id="element-1096">
        {activities.map(activity => <div key={activity.id} className="flex items-start" data-id="element-1097">
            <div className="flex-shrink-0 mt-1 mr-2" data-id="element-1098">
              {getActivityIcon(activity)}
            </div>
            <div className="flex-1 min-w-0" data-id="element-1099">
              <p className="text-sm text-gray-900 line-clamp-1" data-id="element-1100">
                <span className="font-medium" data-id="element-1101">{activity.person}</span>{' '}
                {activity.type === 'engagement' && `${activity.action} ${activity.target}`}
                {activity.type === 'connection' && `connected with you`}
                {activity.type === 'message' && `sent you a message`}
              </p>
              {activity.type === 'connection' && <p className="text-xs text-gray-500" data-id="element-1102">{activity.position}</p>}
              {activity.type === 'message' && <p className="text-xs text-gray-500 italic" data-id="element-1103">
                  {activity.preview}
                </p>}
            </div>
            <div className="flex-shrink-0 ml-2 flex items-center text-xs text-gray-500" data-id="element-1104">
              <ClockIcon size={12} className="mr-1" data-id="element-1105" />
              {activity.time}
            </div>
          </div>)}
      </div>
    </div>;
};